import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getSection, updateSection} from 'src/openapi/admin/apis/ConferenceSectionsApi';
import {SectionIconType as SectionIconTypes} from 'src/openapi/admin/models/SectionIconType';
import {SectionType as SectionTypes} from 'src/openapi/admin/models/SectionType';
import {useAppDispatch} from 'src/store/hooks';

import type {SectionRequest} from 'src/openapi/admin/models/SectionRequest';

type Props = {
    sectionId: number,
    conferenceId: number,
};

export const useEditSection = ({sectionId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => apiDispatch(
        getSection({sectionId}, {signal}),
    ), [sectionId, apiDispatch]);

    const saveDispatchAction = useCallback((
        sectionRequest: SectionRequest,
        signal: AbortSignal,
    ) => apiDispatch(
        updateSection({sectionId, sectionRequest}, {signal}),
    ), [sectionId, apiDispatch]);

    return useCommonDataHook({
        initValue: {
            conferenceId: 0,
            sectionType: SectionTypes.CUSTOM,
            sectionName: '',
            iconType: SectionIconTypes.AGENDA,
            webVersionEnabled: false,
            mobileVersionEnabled: false,
            order: 0,
        },
        getDispatchAction,
        saveDispatchAction,
    });
};
